(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ev-card-gallery')) {
    customElements.define('ev-card-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const track = this.querySelector('.ev-card-gallery__track');
        let start = null;
        let blockUntil = 0;
        track.addEventListener('touchstart', event => {
          start = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
        }, { ...options, passive: true });
        track.addEventListener('touchmove', event => {
          if (!start || event.touches.length !== 1) { start = null; return; }
          const dx = Math.abs(event.touches[0].clientX - start.x);
          const dy = Math.abs(event.touches[0].clientY - start.y);
          if (dx > 12 && dx > dy) blockUntil = Date.now() + 600;
        }, { ...options, passive: true });
        track.addEventListener('touchend', () => { start = null; }, options);
        track.addEventListener('touchcancel', () => { start = null; }, options);
        track.addEventListener('click', event => {
          if (Date.now() < blockUntil) { event.preventDefault(); event.stopImmediatePropagation(); }
        }, { ...options, capture: true });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
